import { LoadingOutlined } from "@ant-design/icons";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Spin } from "antd";
import { BrowserRouter, Route, Router, Routes } from "react-router-dom";
import Container from "./components/Container";
import CreditCardPage from "./pages/CreditCardPage";
import DashboardPage from "./pages/DashboardPage";
import LoginPage from "./pages/LoginPage";
// import UserPage from "./pages/UserPage";
import UsersPage from "./pages/UsersPage";
import NoTransactionsUserPage from "./pages/NoTransactionsUserPage";
import withAuthentication from "./components/withAuthenticator";
import FactoryPage from "./pages/FactoryPage";
import UserPage from "./pages/UserPage";
import CampaignsPage from "./pages/CampaignsPage";
import CampaignPage from "./pages/CampaignPage";
import TranslationPage from "./pages/TranslationPage";
import AppNotificationsPage from "./pages/AppNotificationsPage";
import AppNotificationPage from "./pages/AppNotificationPage";
import TransactionsPage from "./pages/TransactionsPage";
import TransactionPage from "./pages/TransactionPage";
import CampaignRulesPage from "./pages/CampaignRulesPage";

Spin.setDefaultIndicator(
  <LoadingOutlined
    style={{
      animationDuration: ".2s",
    }}
  />
);
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="login" element={<LoginPage />} />
          <Route element={<Container />}>
            <Route index element={<DashboardPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="users/:userID" element={<UserPage />} />
            <Route path="transactions" element={<TransactionsPage />} />
            {/* <Route path="transaction/:uuid" element={<TransactionPage />} /> */}
            <Route path="campaigns" element={<CampaignsPage />} />
            <Route path="campaign/:campaign_id" element={<CampaignPage />} />
            {/* <Route path="creditcards" element={<CreditCardPage />} /> */}
            <Route path="notransaction" element={<NoTransactionsUserPage />} />
            {/* <Route path="inventory" element={<FactoryPage />} /> */}
            <Route path="translation" element={<TranslationPage />} />
            <Route path="notification" element={<AppNotificationsPage />} />
            <Route path="notification/:template_id" element={<AppNotificationPage />} />
            <Route path="campaign-rules" element={<CampaignRulesPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default withAuthentication(App);
